/**
 * Registers Chart.js building blocks used across the site.
 * @see https://www.chartjs.org/
 *
 * Chart.js v3+ is tree-shakeable: the bundler only includes imported modules,
 * and each scale/element must be registered before use. We import and register
 * them explicitly here so chart components do not fail at runtime.
 */
import {
  ArcElement,
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  Tooltip,
} from 'chart.js'

let registered = false

export function registerChartJs(): void {
  if (registered) return

  ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    LineElement,
    PointElement,
    ArcElement,
    Legend,
    Tooltip
  )

  registered = true
}
